export default __webpack_public_path__ + "static/media/ebox-blue.60d25742.png";